/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2023 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import {NavConfig} from '../utils';

const IGNORE_TRIRIGA_USER_TIMEOUT = -9999;

let userSession = {
    active: false,
    isAboutToExpire: false,
    millisBeforeExpiration: 0,
    isSSO: false,
    isIgnoreTimeout: false,
    ouathProfileName: null
};

export const SESSION_WARNING_THRESHOLD = 120000;

export async function checkUserSessionStatus(){
    await fetch('../../api/v1/session/status')
    .then((response) => { 
        return response.text();
    })
    .then(sessionState => {
        userSession.active = sessionState.includes('active');
    });
}

export async function fetchIsSSO() {
    await fetch('../../api/v1/session/is-sso')
    .then((response) => {
        return response.json();
    })
    .then(isSSO => {
        userSession.isSSO = isSSO;
    })
}


export async function fetchOAuthLoginProfile() {
    await fetch('../../api/v1/session/oauth-profile')
        .then((response) => {
            return response.text();
        })
        .then(ouathProfileName => {
            userSession.ouathProfileName = ouathProfileName;
        })
}

export async function fetchMillisToExpire() {
    await fetch('../../api/v1/session/millis-to-expire')
    .then((response) => { 
        return response.json();
    })
    .then(millisToExpire => {
        let millisToExpireNum = Number(millisToExpire);
        //Should timeout be ignored.
        if (millisToExpireNum === IGNORE_TRIRIGA_USER_TIMEOUT) {   
          userSession.isIgnoreTimeout = true;
          return;
        }
        userSession.millisBeforeExpiration = millisToExpireNum;
        if(userSession.millisBeforeExpiration <= SESSION_WARNING_THRESHOLD)
            userSession.isAboutToExpire = true;
        else 
            userSession.isAboutToExpire = false;
    });
}

export async function updateUserSession(){

    const requestOptions = {
        method: 'POST',
    };

    return await fetch('../../api/v1/session/update', requestOptions)
      .then((response) => {
        return response.status;
      });
}



export function userHasActiveSession() {
    return userSession.active;
}

export function getMillisBeforeExpiration() {
    return userSession.millisBeforeExpiration;
}

export function isSessionAboutToExpire() {
    return userSession.isAboutToExpire;
}

export function isSSO() {
    return userSession.isSSO;
}

export function ouathProfileName() {
    return userSession.ouathProfileName;
}

export function isIgnoreTimeout() {
    return userSession.isIgnoreTimeout;
}

export async function handleCurrentContextUser(currentUser) {
    if(userHasActiveSession()){
        await NavConfig.getNavConfigAndUserData();
        let contextProps = NavConfig.getNavConfigData();
        return contextProps.userProfile.userAccount
    } else {
        return currentUser;
    }
}
